import { render } from "./BuildSkills.vue?vue&type=template&id=75d50eac&scoped=true&ts=true"
import script from "./BuildSkills.vue?vue&type=script&lang=ts"
export * from "./BuildSkills.vue?vue&type=script&lang=ts"

import "./BuildSkills.vue?vue&type=style&index=0&id=75d50eac&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-75d50eac"]])

export default __exports__